(function() {

  var dropdownStyles = new CSSStyleSheet;
  dropdownStyles.replaceSync(`
   .rc-plans-dropdown__select{
     border: none !important;
     background-color: #F2EDE1 !important;
     font-family: 'Morion';
     font-size: 14px;
     padding: 12px 16px;
   }

   .option-buttons-container{
     display: flex;
     gap: 1rem;
     justify-content: space-between;
   }
   .option-button{
     font-family: 'Apercu';
     padding: 12px;
     font-size: 14px;
     font-weight: 400;
     line-height: 20px;
     background: none;
     border: .5px solid lightgray;
     display: flex;
     align-items: center;
     gap: .8rem;
     width: 100%;
     color: black;
   }
   .option-button.active{
     background: #F2EDE1;
     border: none;
   }
   .option-button .option-icon {
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid #888;
    background-color: transparent;
    transition: all 0.3s;
  }
  @media only screen and (max-width: 875px){
     .option-button .option-icon {
        width: 22px !important;
    }
  }
.option-button.active .option-icon{
    background-color: black;
    border: none;
    height: 15px;
    width: 15px;
}
.option-button.active .option-icon::before {
    content: "";
    width: 12px;
    height: 12px;
    border: 2px solid black;
    border-radius: 50%;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 13l4 4L19 7'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
}

  `);

  var styles = new CSSStyleSheet;
  styles.replaceSync(`
  .rc-purchase-option__selector{
    font-family: 'Morion';
    font-size: 16px;
    margin-top: .5rem;
  }
  
   rc-benefits{
     border: none !important;
     background-color: #F2EDE1 !important;
     font-family: 'Morion';
     font-size: 14px;
     letter-spacing: 0.6px;
   }
  rc-learn-more {
    display: none !important;
  }
  
  rc-selling-plans {
      flex: 1;
  }

    rc-selling-plans select {
      border: none !important;
  }
  
  rc-benefits {
      flex: 2;
      border: 1px solid black;
      padding: 12px;
      margin: 0;
  }
  .rc-purchase-option__sub-container { flex-direction: column-reverse;}
  .rc-price.strike-through.text-muted { *display: none; }
  .rc-purchase-option__badge { display: none; }
  .save-badge {
    font-size: 10px;
    font-weight: 400;
    text-transform: uppercase;
    padding: 8px 12px;
    background: #708266;
    border-radius: 50px;
    line-height: 12px;
    margin-left: 10px;
    color: white;
    text-wrap: nowrap;
    font-family: 'Apercu';
  }
  .delivery-frequency {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
  .rc-purchase-option__prices{
    text-wrap: nowrap;
  }
  .rc-selection__onetime .rc-price { display: unset; }
  .rc-selection__onetime .rc-price[hidden] { display: none; }
  .rc-selection__onetime .rc-purchase-option__prices .black-friday-price + .rc-price { display: none; }
  .cw-bundle-div {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background: #F5F0E1;
    gap: 10px;
    padding: 10px;
  }
  .cw-bundle-div[hidden] { display: none; }
  .cw-bundle-div .cw-bundle-info {
  display: flex;
  flex-direction: column;
  }
  .cw-bundle-div h2 {
      font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    margin: 0;
    color: #403333;
    text-transform: uppercase;
  }
  .cw-bundle-div span {
      font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 0;
    color: #403333;
  }
  @media (min-width: 768px) {
    .cw-bundle-div h2 {
      font-size: 14px;
    font-weight: 700;
    line-height: 24px;
  }
  .cw-bundle-div span {
      font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
  }
  strong.black-friday-price { display: none; }
  strong.black-friday-price >div > div:last-child { display: none; }
  `);

  var benefits = new CSSStyleSheet;
  benefits.replaceSync(`
  .rc-benefits__list li:nth-of-type(1){
    display: none !important;
  }
   .rc-benefits__list{
     font-family: 'Apercu';
   }
   
  .rc-benefits__list li:before {
    mask-size: 100%;
    mask-position: center center;
    mask-repeat: no-repeat;
  }
  
  .rc-benefits__list li:nth-of-type(1):before {
    mask-image: url(data:image/svg+xml;base64,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);
  }
  .rc-benefits__list li:nth-of-type(2):before {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNDEyMTA5IDUuMjM2NzlIMTMuNTg4Nk0zLjcwNjIzIDguNTMwOTFINy4wMDAzNE0xMC4yOTQ1IDEuMTE5MTRWMi43NjYyTTMuNzA2MjMgMS4xMTkxNFYyLjc2NjJNMC40MTIxMDkgMS45NDI2N0gxMy41ODg2VjEzLjQ3MjFDMTMuNTg4NiAxMy45MDg5IDEzLjQxNTEgMTQuMzI3OCAxMy4xMDYyIDE0LjYzNjdDMTIuNzk3MyAxNC45NDU2IDEyLjM3ODMgMTUuMTE5MSAxMS45NDE1IDE1LjExOTFIMi4wNTkxN0MxLjYyMjM0IDE1LjExOTEgMS4yMDM0MSAxNC45NDU2IDAuODk0NTIyIDE0LjYzNjdDMC41ODU2MzggMTQuMzI3OCAwLjQxMjEwOSAxMy45MDg5IDAuNDEyMTA5IDEzLjQ3MjFWMS45NDI2N1oiIHN0cm9rZT0iIzBBMEEwQSIgc3Ryb2tlLXdpZHRoPSIwLjgyMzUyOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=);
  }
  .rc-benefits__list li:nth-of-type(3):before {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNiAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjg1NjcgMS4wNDc3MVYxMC4xOTA2QzExLjg1NjcgMTAuMzA0MiAxMS44MTE2IDEwLjQxMzIgMTEuNzMxMiAxMC40OTM2QzExLjY1MDggMTAuNTc0IDExLjU0MTggMTAuNjE5MSAxMS40MjgyIDEwLjYxOTFDMTEuMzE0NSAxMC42MTkxIDExLjIwNTUgMTAuNTc0IDExLjEyNTEgMTAuNDkzNkMxMS4wNDQ3IDEwLjQxMzIgMTAuOTk5NiAxMC4zMDQyIDEwLjk5OTYgMTAuMTkwNlYxLjA0NzcxQzEwLjk5OTYgMC45MzQwNDggMTEuMDQ0NyAwLjgyNTAzOSAxMS4xMjUxIDAuNzQ0NjY2QzExLjIwNTUgMC42NjQyOTQgMTEuMzE0NSAwLjYxOTE0MSAxMS40MjgyIDAuNjE5MTQxQzExLjU0MTggMC42MTkxNDEgMTEuNjUwOCAwLjY2NDI5NCAxMS43MzEyIDAuNzQ0NjY2QzExLjgxMTYgMC44MjUwMzkgMTEuODU2NyAwLjkzNDA0OCAxMS44NTY3IDEuMDQ3NzFaTTE0Ljg1NjcgMC42MTkxNDFDMTQuNzQzMSAwLjYxOTE0MSAxNC42MzQxIDAuNjY0Mjk0IDE0LjU1MzcgMC43NDQ2NjZDMTQuNDczMyAwLjgyNTAzOSAxNC40MjgyIDAuOTM0MDQ4IDE0LjQyODIgMS4wNDc3MVYxMC4xOTA2QzE0LjQyODIgMTAuMzA0MiAxNC40NzMzIDEwLjQxMzIgMTQuNTUzNyAxMC40OTM2QzE0LjYzNDEgMTAuNTc0IDE0Ljc0MzEgMTAuNjE5MSAxNC44NTY3IDEwLjYxOTFDMTQuOTcwNCAxMC42MTkxIDE1LjA3OTQgMTAuNTc0IDE1LjE1OTggMTAuNDkzNkMxNS4yNDAxIDEwLjQxMzIgMTUuMjg1MyAxMC4zMDQyIDE1LjI4NTMgMTAuMTkwNlYxLjA0NzcxQzE1LjI4NTMgMC45MzQwNDggMTUuMjQwMSAwLjgyNTAzOSAxNS4xNTk4IDAuNzQ0NjY2QzE1LjA3OTQgMC42NjQyOTQgMTQuOTcwNCAwLjYxOTE0MSAxNC44NTY3IDAuNjE5MTQxWk04Ljk5OTU4IDUuNjE5MTRDOC45OTk3MyA1Ljc4NTIyIDguOTU3ODEgNS45NDg2MyA4Ljg3Nzc1IDYuMDk0MTRDOC43OTc2OSA2LjIzOTY1IDguNjgyMDkgNi4zNjI1MSA4LjU0MTcyIDYuNDUxMjhMMi4yNDMxNSAxMC40NjJDMi4wOTMzNCAxMC41NTc5IDEuOTIwNTMgMTAuNjExOCAxLjc0Mjc2IDEwLjYxODJDMS41NjUgMTAuNjI0NSAxLjM4ODc5IDEwLjU4MyAxLjIzMjU0IDEwLjQ5OEMxLjA3NjI5IDEwLjQxMjkgMC45NDU3MzQgMTAuMjg3NSAwLjg1NDQ5OSAxMC4xMzQ4QzAuNzYzMjYzIDkuOTgyMTMgMC43MTQ2OTUgOS44MDc3MyAwLjcxMzg2NyA5LjYyOTg2VjEuNjA4NDNDMC43MTQ2OTUgMS40MzA1NSAwLjc2MzI2MyAxLjI1NjE1IDAuODU0NDk5IDEuMTAzNDVDMC45NDU3MzQgMC45NTA3NDcgMS4wNzYyOSAwLjgyNTMzOSAxLjIzMjU0IDAuNzQwMzE4QzEuMzg4NzkgMC42NTUyOTggMS41NjUgMC42MTM3ODMgMS43NDI3NiAwLjYyMDExQzEuOTIwNTMgMC42MjY0MzYgMi4wOTMzNCAwLjY4MDM3MSAyLjI0MzE1IDAuNzc2Mjg0TDguNTQxNzIgNC43ODdDOC42ODIwOSA0Ljg3NTc3IDguNzk3NjkgNC45OTg2MyA4Ljg3Nzc1IDUuMTQ0MTRDOC45NTc4MSA1LjI4OTY1IDguOTk5NzMgNS40NTMwNiA4Ljk5OTU4IDUuNjE5MTRaTTguMTQyNDQgNS42MTkxNEM4LjE0MjY2IDUuNTk3MjIgOC4xMzcxOCA1LjU3NTYzIDguMTI2NTMgNS41NTY0N0M4LjExNTg5IDUuNTM3MzEgOC4xMDA0NSA1LjUyMTI1IDguMDgxNzIgNS41MDk4NkwxLjc4NTMgMS40OTkxNEMxLjc2NDE2IDEuNDg0ODYgMS43MzkzNyAxLjQ3NjkyIDEuNzEzODcgMS40NzYyOEMxLjY4ODk0IDEuNDc2MjEgMS42NjQzOSAxLjQ4MjM1IDEuNjQyNDQgMS40OTQxNEMxLjYyMDkxIDEuNTA0NDUgMS42MDI3NiAxLjUyMDY2IDEuNTkwMTIgMS41NDA5QzEuNTc3NDcgMS41NjExNCAxLjU3MDg0IDEuNTg0NTYgMS41NzEwMSAxLjYwODQzVjkuNjI5ODZDMS41NzA4NCA5LjY1MzcyIDEuNTc3NDcgOS42NzcxNCAxLjU5MDEyIDkuNjk3MzhDMS42MDI3NiA5LjcxNzYyIDEuNjIwOTEgOS43MzM4NCAxLjY0MjQ0IDkuNzQ0MTRDMS42NjQzNiA5Ljc1NjY4IDEuNjg5MzQgOS43NjI4NiAxLjcxNDU4IDkuNzYxOTdDMS43Mzk4MiA5Ljc2MTA5IDEuNzY0MzEgOS43NTMxOCAxLjc4NTMgOS43MzkxNEw4LjA4NDU4IDUuNzI4NDNDOC4xMDI3OCA1LjcxNjY5IDguMTE3NjUgNS43MDA0OCA4LjEyNzc4IDUuNjgxMzRDOC4xMzc5MSA1LjY2MjIgOC4xNDI5NiA1LjY0MDc5IDguMTQyNDQgNS42MTkxNFoiIGZpbGw9IiMwQTBBMEEiLz4KPC9zdmc+Cg==);
  }
  .rc-benefits__list li:nth-of-type(5):before {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgLTIgMjIgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjUxNzMzIDE0Ljk3MDFDOC41MTczMyAxNi4yMTkgNy41Mjg4OSAxNy4yMzIzIDYuMzEwMjIgMTcuMjMyM0M1LjA5MTU2IDE3LjIzMjMgNC4xMDMxMSAxNi4yMTkgNC4xMDMxMSAxNC45NjkyTTguNTE3MzMgMTQuOTcwMUM4LjUxNzMzIDEzLjcyMTIgNy41Mjg4OSAxMi43MDcgNi4zMTAyMiAxMi43MDdDNS4wOTE1NiAxMi43MDcgNC4xMDMxMSAxMy43MjAzIDQuMTAzMTEgMTQuOTY5Mk04LjUxNzMzIDE0Ljk3MDFMMTMuNDgyNyAxNC45NjkyTTQuMTAzMTEgMTQuOTY5MkgzVjUuNjc2NzZDMyA1LjQ0MTAxIDMuMDkzNjUgNS4yMTQ5MiAzLjI2MDM1IDUuMDQ4MjJDMy40MjcwNSA0Ljg4MTUyIDMuNjUzMTQgNC43ODc4NyAzLjg4ODg5IDQuNzg3ODdIMTIuNTkzOEMxMi44Mjk1IDQuNzg3ODcgMTMuMDU1NiA0Ljg4MTUyIDEzLjIyMjMgNS4wNDgyMkMxMy4zODkgNS4yMTQ5MiAxMy40ODI3IDUuNDQxMDEgMTMuNDgyNyA1LjY3Njc2VjcuNjE2MzJNMTMuNDgyNyAxNC45NjkySDE0LjAzNDdNMTMuNDgyNyAxNC45NjkyVjcuNjE2MzJNMTMuNDgyNyA3LjYxNjMySDE1LjQ5MjRDMTUuNzI5NSA3LjYxNjM0IDE1Ljk2NDEgNy42NjM3OCAxNi4xODI2IDcuNzU1ODNDMTYuNDAxIDcuODQ3ODggMTYuNTk4OSA3Ljk4MjY4IDE2Ljc2NDQgOC4xNTIzMkwxOSAxMC40NDQ4VjE0Ljk2OTJIMTguNDQ4TTE4LjQ0OCAxNC45NjkyQzE4LjQ0OCAxNi4yMTkgMTcuNDYwNCAxNy4yMzIzIDE2LjI0MTggMTcuMjMyM0MxNS4wMjMxIDE3LjIzMjMgMTQuMDM0NyAxNi4yMTkgMTQuMDM0NyAxNC45NjkyTTE4LjQ0OCAxNC45NjkyQzE4LjQ0OCAxMy43MjAzIDE3LjQ2MDQgMTIuNzA3IDE2LjI0MTggMTIuNzA3QzE1LjAyMzEgMTIuNzA3IDE0LjAzNDcgMTMuNzIwMyAxNC4wMzQ3IDE0Ljk2OTIiIHN0cm9rZT0iIzFFMUUxRSIgc3Ryb2tlLXdpZHRoPSIxLjA1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==);
    } 
  `);
  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  const areElementsLoaded = async (document, selector) => {
    while ( document.querySelectorAll(selector).length <= 0) {
      await new Promise( resolve =>  requestAnimationFrame(resolve) )
    }
    return document.querySelectorAll(selector);
  };

  function waitForProp(obj, prop, callback) {
    const inter = setInterval(function() {
      if (obj[prop]) {
        clearInterval(inter);
        callback();
      }
    }, 50);
  }
  (() => {
      let oldPushState = history.pushState;
      history.pushState = function pushState() {
          let ret = oldPushState.apply(this, arguments);
          window.dispatchEvent(new Event('pushstate'));
          window.dispatchEvent(new Event('locationchange'));
          return ret;
      };
  
      let oldReplaceState = history.replaceState;
      history.replaceState = function replaceState() {
          let ret = oldReplaceState.apply(this, arguments);
          window.dispatchEvent(new Event('replacestate'));
          window.dispatchEvent(new Event('locationchange'));
          return ret;
      };
  
      window.addEventListener('popstate', () => {
          window.dispatchEvent(new Event('locationchange'));
      });
  })();

  function checkUrl() {
    areElementsLoaded(document, 'recharge-subscription-widget').then((elements) => {
      waitForProp(elements[0], 'shadowRoot', function() {
        console.log('bundle-div', elements[0].shadowRoot.querySelector('.cw-bundle-div'))
        if ((location.href.indexOf('sweet-sleep-magnesium-butter') !== -1 && location.href.indexOf('variant') === -1) || location.href.indexOf('30939525021814') !== -1 || location.href.indexOf('30939525054582') !== -1 || location.href.indexOf('40780543066230') !== -1 || location.href.indexOf('40780543098998') !== -1) {
            //elements[0].shadowRoot.querySelector('.cw-bundle-div').removeAttribute('hidden');
        } else {
            elements[0].shadowRoot.querySelector('.cw-bundle-div').setAttribute('hidden', true);
        }
      });
    });
  }

    if (window.navigation)
      window.navigation.addEventListener("navigate", checkUrl);
    else 
      window.addEventListener('locationchange', function () {
        checkUrl();
      });
  checkUrl();
  
  areElementsLoaded(document, 'recharge-subscription-widget').then((elements) => {
      const root = elements[0].shadowRoot; 
    
      waitForProp(elements[0], 'shadowRoot', function() {
        elements[0].shadowRoot.adoptedStyleSheets.push(styles);
        
        areElementsLoaded(elements[0].shadowRoot, '.rc-purchase-option__sub-container').then((elements) => {
          const span = document.createElement('span');
          span.innerHTML = 'Delivery frequency:';
          span.classList.add('delivery-frequency');
          elements[0].appendChild(span);


          const bundleDiv = document.createElement('div');
          bundleDiv.classList.add('cw-bundle-div');
          bundleDiv.innerHTML = `
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.7037 12.3195V19.8395C18.7037 19.9025 18.6913 19.9649 18.6672 20.0231C18.6431 20.0814 18.6077 20.1343 18.5631 20.1789C18.5186 20.2234 18.4656 20.2588 18.4074 20.2829C18.3492 20.307 18.2867 20.3195 18.2237 20.3195H6.38371C6.32068 20.3195 6.25826 20.307 6.20002 20.2829C6.14179 20.2588 6.08887 20.2234 6.0443 20.1789C5.99973 20.1343 5.96437 20.0814 5.94025 20.0231C5.91613 19.9649 5.90371 19.9025 5.90371 19.8395V12.3195M12.3037 20.3195V8.31946M12.3037 8.31946H8.70371C8.17328 8.31946 7.66457 8.10874 7.2895 7.73367C6.91442 7.3586 6.70371 6.84989 6.70371 6.31946C6.70371 5.78903 6.91442 5.28032 7.2895 4.90524C7.66457 4.53017 8.17328 4.31946 8.70371 4.31946C11.5037 4.31946 12.3037 8.31946 12.3037 8.31946ZM12.3037 8.31946H15.9037C16.4341 8.31946 16.9429 8.10874 17.3179 7.73367C17.693 7.3586 17.9037 6.84989 17.9037 6.31946C17.9037 5.78903 17.693 5.28032 17.3179 4.90524C16.9429 4.53017 16.4341 4.31946 15.9037 4.31946C13.1037 4.31946 12.3037 8.31946 12.3037 8.31946ZM19.8237 8.31946H4.78371C4.65641 8.31946 4.53432 8.37003 4.4443 8.46005C4.35428 8.55006 4.30371 8.67215 4.30371 8.79946V11.8395C4.30371 11.9668 4.35428 12.0889 4.4443 12.1789C4.53432 12.2689 4.65641 12.3195 4.78371 12.3195H19.8237C19.951 12.3195 20.0731 12.2689 20.1631 12.1789C20.2531 12.0889 20.3037 11.9668 20.3037 11.8395V8.79946C20.3037 8.67215 20.2531 8.55006 20.1631 8.46005C20.0731 8.37003 19.951 8.31946 19.8237 8.31946Z" stroke="#0A0A0A" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <div class="cw-bundle-info">
            <h2>FREE Mini bundle with your 1st subscription order</h2>
            <span>This Black Friday weekend only</span>
            </div>
          `;
          
          elements[0].prepend(bundleDiv);
          bundleDiv.setAttribute('hidden', true);
          checkUrl();
        });
  
  
        areElementsLoaded(elements[0].shadowRoot, '.rc-purchase-option__badge').then((badges) => {
          areElementsLoaded(elements[0].shadowRoot, '.rc-purchase-option__selector').then((elements) => {
            const saveBadge = document.createElement('span');
            saveBadge.innerHTML = 'save ' + badges[0].innerText;
            saveBadge.classList.add('save-badge');
            console.log("SAVE BADGE ADDED");
            elements[0].appendChild(saveBadge);

            var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === 'characterData') {
                  saveBadge.innerHTML = 'save ' + badges[0].innerText;
                }
              });
            });
            
            
            observer.observe(badges[0], { attributes: false, childList: true, characterData: true, subtree:true });
            
          });
        });
      areElementsLoaded(elements[0].shadowRoot, 'rc-benefits').then((list) => {
        list[0].shadowRoot.adoptedStyleSheets.push(benefits);
        })
          areElementsLoaded(elements[0].shadowRoot, 'rc-selling-plans').then((list) => {
            if (list[0]?.shadowRoot) {
              list[0].shadowRoot.adoptedStyleSheets.push(dropdownStyles);
            }
          });
    areElementsLoaded(elements[0].shadowRoot, 'rc-selling-plans').then((list) => {
    if (list[0]?.shadowRoot) {
      const selectElement = list[0].shadowRoot.firstElementChild;
      const hiddenInput = document.querySelector('input[name="selling_plan"]');
      console.log("SELECT ELEMENT", selectElement);
      if (window.innerWidth > 875 && !selectElement.parentNode.querySelector('.option-buttons-container')) {
        const selectElement2 = selectElement.querySelector('.rc-plans-dropdown__select');
               selectElement2.style.display = 'none';
        selectElement.querySelector('.rc-plans-dropdown__icon').style.display = 'none';
        const buttonContainer = document.createElement('div');
        buttonContainer.classList.add('option-buttons-container');
    Array.from(selectElement2.options).forEach((option, index) => {
        const button = document.createElement('button');
        button.classList.add('option-button');
        button.setAttribute('data-value', option.value);

        const iconSpan = document.createElement('span');
        iconSpan.classList.add('option-icon');

        const textSpan = document.createElement('span');
        let text = option.textContent.trim(); 
        let words = text.split(' ');

        if (words.length > 1) {
            words.shift(); 
            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
        }
        
        textSpan.textContent = words.join(' ');

        button.appendChild(iconSpan);
        button.appendChild(textSpan);

        if (index === 0) {
            button.classList.add('active');
            hiddenInput.value = option.value;
        }

        button.addEventListener('click', () => {
            selectElement2.value = option.value;
            selectElement2.dispatchEvent(new Event('change'));
            hiddenInput.value = option.value;

            buttonContainer.querySelectorAll('.option-button').forEach(btn => {
                btn.classList.remove('active');
            });

            button.classList.add('active');
        });

        buttonContainer.appendChild(button);
    });

      selectElement.parentNode.insertBefore(buttonContainer, selectElement.nextSibling);
      }
      list[0].shadowRoot.adoptedStyleSheets.push(dropdownStyles);
    }
  });
      });
  });
  
})();